import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, isRef as _isRef, withCtx as _withCtx, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createVNode as _createVNode, createTextVNode as _createTextVNode, normalizeStyle as _normalizeStyle, vShow as _vShow, withDirectives as _withDirectives } from "vue"
import _imports_0 from '@/assets/images/vk_ts_line.png'


const _hoisted_1 = { class: "remote-container" }
const _hoisted_2 = { class: "top" }
const _hoisted_3 = { class: "left" }
const _hoisted_4 = { class: "icon" }
const _hoisted_5 = ["src"]
const _hoisted_6 = {
  key: 1,
  class: "discenect remote-name"
}
const _hoisted_7 = { class: "right" }
const _hoisted_8 = { class: "progress-container" }
const _hoisted_9 = { class: "name text" }
const _hoisted_10 = { class: "text" }
const _hoisted_11 = { class: "progress" }
const _hoisted_12 = { class: "text" }
const _hoisted_13 = { class: "selects" }
const _hoisted_14 = { class: "bottom" }
const _hoisted_15 = { class: "tutorial-container" }
const _hoisted_16 = { class: "tutorial-text-cotainer" }
const _hoisted_17 = { class: "modal-body" }
const _hoisted_18 = { class: "step-title" }
const _hoisted_19 = { class: "step-conent" }
const _hoisted_20 = { class: "progress-container" }
const _hoisted_21 = {
  key: 0,
  class: "num"
}
const _hoisted_22 = { class: "remote-set" }
const _hoisted_23 = { class: "square left" }
const _hoisted_24 = { class: "square right" }
const _hoisted_25 = { class: "btn-container" }
const _hoisted_26 = { class: "model-footer" }

import { NScrollbar, NCheckbox, NProgress, NTooltip, NSelect } from 'naive-ui'
import useRemote from './index';

export default /*@__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

const {
    romoteCenect,
    chanleList,
    loading,
    remoteDirection,
    stickTypeList,
    keyTypeListA,
    keyTypeListB,
    actionType,
    stepTitle,
    stepContent,
    showModal,
    remoteIcon,
    remoteName,
    calibrateDisabled,
    leftX,
    leftY,
    rightX,
    rightY,
    isGetStickValueStart,
    isGetStickValueEnd,
    progress5Num,
    showPrompt,
    confirmLoading,
    disconnect,
    handleCalibrate,
    handleResetDefault,
    handleSave,
    handleClose,
    onUpdateStickType,
    onUpdateKeyType,
    setStickCenterValue,
    handleAgainCalibrate,
    getJoystickPercentage,
    playClickSound,
    confirmCalibrate,
    handleJumpTutorial,
    handleConfirmResetDefault,
    connectedRemoteOptions,
    selectedGamepadIndex,
    handleRemoteSelectChange,
} = useRemote();

return (_ctx: any,_cache: any) => {
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_vkn_button = _resolveComponent("vkn-button")!
  const _component_vkm_modal = _resolveComponent("vkm-modal")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("img", {
            src: _unref(remoteIcon),
            alt: ""
          }, null, 8, _hoisted_5),
          (!_unref(disconnect)())
            ? (_openBlock(), _createBlock(_component_el_select, {
                key: 0,
                modelValue: _unref(selectedGamepadIndex),
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(selectedGamepadIndex) ? (selectedGamepadIndex).value = $event : null)),
                class: "remote-select",
                placeholder: "请选择设备",
                teleported: false,
                onChange: _unref(handleRemoteSelectChange)
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(connectedRemoteOptions), (item) => {
                    return (_openBlock(), _createBlock(_component_el_option, {
                      key: item.value,
                      label: item.label,
                      value: item.value
                    }, null, 8, ["label", "value"]))
                  }), 128))
                ]),
                _: 1
              }, 8, ["modelValue", "onChange"]))
            : (_openBlock(), _createElementBlock("p", _hoisted_6, _toDisplayString(_unref(remoteName)), 1))
        ]),
        _createVNode(_component_vkn_button, {
          label: "校准",
          class: "button",
          type: "primary",
          size: "medium",
          onClick: _unref(handleCalibrate),
          disabled: _unref(calibrateDisabled) || _unref(disconnect)()
        }, null, 8, ["onClick", "disabled"]),
        _createVNode(_component_vkn_button, {
          label: "恢复默认",
          class: "button restore-default",
          type: "info",
          size: "medium",
          disabled: _unref(calibrateDisabled) || _unref(disconnect)(),
          onClick: _unref(handleResetDefault)
        }, null, 8, ["disabled", "onClick"])
      ]),
      _createElementVNode("div", _hoisted_7, [
        _createVNode(_unref(NScrollbar), null, {
          default: _withCtx(() => [
            _cache[4] || (_cache[4] = _createElementVNode("div", { class: "space" }, null, -1)),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(chanleList), (item, index) => {
              return (_openBlock(), _createElementBlock("div", {
                class: "channel-item-container",
                key: index
              }, [
                _createElementVNode("div", _hoisted_8, [
                  _createElementVNode("span", _hoisted_9, _toDisplayString(item.name), 1),
                  _createElementVNode("span", _hoisted_10, _toDisplayString(item.keyCode==='throttle'?'降': 
                                    item.keyCode==='roll'?'左': 
                                    item.keyCode==='pitch'?'后': 
                                    item.keyCode==='yaw'?'逆': '小'), 1),
                  _createElementVNode("div", _hoisted_11, [
                    (item.valueType===1)
                      ? (_openBlock(), _createBlock(_unref(NProgress), {
                          key: 0,
                          type: "line",
                          percentage: _unref(getJoystickPercentage)(item),
                          "indicator-placement": "inside",
                          reverse: item.reverse
                        }, null, 8, ["percentage", "reverse"]))
                      : (_openBlock(), _createBlock(_unref(NProgress), {
                          key: 1,
                          type: "line",
                          percentage: item.reverse?(((item.value * -1) * 100) / 2 + 50):((item.value * 100) / 2 + 50),
                          "indicator-placement": "inside",
                          reverse: item.reverse
                        }, null, 8, ["percentage", "reverse"]))
                  ]),
                  _createElementVNode("span", _hoisted_12, _toDisplayString(item.keyCode==='throttle'?'升': 
                                    item.keyCode==='roll'?'右': 
                                    item.keyCode==='pitch'?'前': 
                                    item.keyCode==='yaw'?'顺': '大'), 1),
                  _createVNode(_unref(NCheckbox), {
                    checked: item.reverse,
                    "onUpdate:checked": ($event: any) => ((item.reverse) = $event),
                    disabled: _unref(disconnect)(),
                    onClick: _unref(playClickSound)
                  }, {
                    default: _withCtx(() => _cache[3] || (_cache[3] = [
                      _createTextVNode("反向")
                    ])),
                    _: 2
                  }, 1032, ["checked", "onUpdate:checked", "disabled", "onClick"]),
                  _createElementVNode("div", _hoisted_13, [
                    _createVNode(_unref(NSelect), {
                      class: "select",
                      value: item.stickType,
                      "onUpdate:value": [($event: any) => ((item.stickType) = $event), ($event: any) => (_unref(onUpdateStickType)(item,index))],
                      options: _unref(stickTypeList),
                      "show-checkmark": false,
                      onClick: _unref(playClickSound),
                      placeholder: "请选择"
                    }, null, 8, ["value", "onUpdate:value", "options", "onClick"]),
                    _createVNode(_unref(NSelect), {
                      class: "select select2",
                      value: item.keyCode,
                      "onUpdate:value": [($event: any) => ((item.keyCode) = $event), ($event: any) => (_unref(onUpdateKeyType)(item,index))],
                      options: item.keyCode==='throttle' || item.keyCode==='roll' || item.keyCode==='pitch' || item.keyCode==='yaw' || item.stickType ? _unref(keyTypeListA):_unref(keyTypeListB),
                      "show-checkmark": false,
                      "label-field": "keyName",
                      "value-field": "keyCode",
                      onClick: _unref(playClickSound)
                    }, null, 8, ["value", "onUpdate:value", "options", "onClick"])
                  ])
                ])
              ]))
            }), 128)),
            _cache[5] || (_cache[5] = _createElementVNode("div", { class: "space" }, null, -1))
          ]),
          _: 1
        })
      ])
    ]),
    _createElementVNode("div", _hoisted_14, [
      _cache[7] || (_cache[7] = _createElementVNode("div", { class: "text" }, "设置完成后，请保存设置", -1)),
      _createElementVNode("div", _hoisted_15, [
        _createElementVNode("p", _hoisted_16, [
          _cache[6] || (_cache[6] = _createElementVNode("span", null, "遇到问题？", -1)),
          _createElementVNode("span", {
            onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_unref(handleJumpTutorial) && _unref(handleJumpTutorial)(...args)))
          }, "查看教程")
        ]),
        _createVNode(_component_vkn_button, {
          class: "insert-btn",
          label: "保存设置",
          type: "primary",
          loading: _unref(loading),
          "icon-placement": "left",
          disabled: _unref(disconnect)(),
          size: "large",
          onClick: _unref(handleSave)
        }, null, 8, ["loading", "disabled", "onClick"])
      ])
    ]),
    _withDirectives(_createVNode(_component_vkm_modal, {
      title: "校准",
      onOnClose: _unref(handleClose)
    }, {
      content: _withCtx(() => [
        _createElementVNode("div", _hoisted_17, [
          _createElementVNode("p", _hoisted_18, _toDisplayString(_unref(stepTitle)), 1),
          _createElementVNode("p", _hoisted_19, _toDisplayString(_unref(stepContent)), 1),
          _createElementVNode("div", _hoisted_20, [
            _cache[8] || (_cache[8] = _createElementVNode("div", { class: "progress5" }, null, -1)),
            (_unref(isGetStickValueStart) && _unref(progress5Num))
              ? (_openBlock(), _createElementBlock("div", _hoisted_21, _toDisplayString(_unref(progress5Num)), 1))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_22, [
            _createElementVNode("div", _hoisted_23, [
              _cache[9] || (_cache[9] = _createElementVNode("div", { class: "x" }, null, -1)),
              _cache[10] || (_cache[10] = _createElementVNode("div", { class: "y" }, null, -1)),
              _createElementVNode("div", {
                class: "point",
                style: _normalizeStyle({left:`${_unref(leftX)}%`, top:`${_unref(leftY)}%`})
              }, null, 4),
              _cache[11] || (_cache[11] = _createElementVNode("div", { class: "leftA1" }, null, -1)),
              _cache[12] || (_cache[12] = _createElementVNode("div", { class: "leftB" }, null, -1)),
              _cache[13] || (_cache[13] = _createElementVNode("div", { class: "leftC" }, null, -1)),
              _cache[14] || (_cache[14] = _createElementVNode("div", { class: "leftD" }, null, -1)),
              _cache[15] || (_cache[15] = _createElementVNode("div", { class: "leftA2" }, null, -1)),
              _cache[16] || (_cache[16] = _createElementVNode("div", { class: "leftPoint" }, null, -1))
            ]),
            _createElementVNode("div", _hoisted_24, [
              _cache[17] || (_cache[17] = _createElementVNode("div", { class: "x" }, null, -1)),
              _cache[18] || (_cache[18] = _createElementVNode("div", { class: "y" }, null, -1)),
              _createElementVNode("div", {
                class: "point",
                style: _normalizeStyle({left:`${_unref(rightX)}%`, top:`${_unref(rightY)}%`})
              }, null, 4),
              _cache[19] || (_cache[19] = _createElementVNode("div", { class: "rightA1" }, null, -1)),
              _cache[20] || (_cache[20] = _createElementVNode("div", { class: "rightB" }, null, -1)),
              _cache[21] || (_cache[21] = _createElementVNode("div", { class: "rightC" }, null, -1)),
              _cache[22] || (_cache[22] = _createElementVNode("div", { class: "rightD" }, null, -1)),
              _cache[23] || (_cache[23] = _createElementVNode("div", { class: "rightA2" }, null, -1)),
              _cache[24] || (_cache[24] = _createElementVNode("div", { class: "rightPoint" }, null, -1))
            ])
          ])
        ])
      ]),
      footer: _withCtx(() => [
        _createElementVNode("div", _hoisted_25, [
          (!_unref(isGetStickValueStart))
            ? (_openBlock(), _createBlock(_component_vkn_button, {
                key: 0,
                label: "确定",
                type: "primary",
                size: "large",
                onClick: _unref(setStickCenterValue)
              }, null, 8, ["onClick"]))
            : _createCommentVNode("", true),
          (_unref(isGetStickValueStart) && _unref(isGetStickValueEnd))
            ? (_openBlock(), _createBlock(_component_vkn_button, {
                key: 1,
                label: "重新校准",
                type: "info",
                size: "large",
                onClick: _unref(handleAgainCalibrate)
              }, null, 8, ["onClick"]))
            : _createCommentVNode("", true),
          (_unref(isGetStickValueStart) && _unref(isGetStickValueEnd))
            ? (_openBlock(), _createBlock(_component_vkn_button, {
                key: 2,
                label: "完成",
                type: "primary",
                size: "large",
                onClick: _unref(confirmCalibrate)
              }, null, 8, ["onClick"]))
            : _createCommentVNode("", true)
        ])
      ]),
      _: 1
    }, 8, ["onOnClose"]), [
      [_vShow, _unref(showModal)]
    ]),
    (_unref(showPrompt))
      ? (_openBlock(), _createBlock(_component_vkm_modal, {
          key: 0,
          class: "prompt-modal-container",
          title: "提示",
          isShowCloseIcon: false
        }, {
          content: _withCtx(() => _cache[25] || (_cache[25] = [
            _createElementVNode("div", { class: "prompt-content" }, [
              _createElementVNode("img", {
                src: _imports_0,
                alt: ""
              }),
              _createElementVNode("p", { class: "prompt-text" }, "恢复默认会将已校准数据还原到默认数据，确定要恢复？")
            ], -1)
          ])),
          footer: _withCtx(() => [
            _createElementVNode("div", _hoisted_26, [
              _createVNode(_component_vkn_button, {
                label: "取消",
                type: "info",
                size: "medium",
                onClick: _cache[2] || (_cache[2] = ()=>{showPrompt.value=false})
              }),
              _createVNode(_component_vkn_button, {
                label: "确定",
                type: "primary",
                size: "medium",
                loading: _unref(confirmLoading),
                onClick: _unref(handleConfirmResetDefault)
              }, null, 8, ["loading", "onClick"])
            ])
          ]),
          _: 1
        }))
      : _createCommentVNode("", true)
  ]))
}
}

})